import React, { useState } from "react";
import { FaBox, FaCube, FaShoppingBag } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const models = [
  { name: "Minimal", category: "Display", image: "images/newminimal1.jpg", description: "A sleek and modern display model, perfect for premium chocolate brands.", route: "/minimal" },
  { name: "Iris", category: "Display", image: "images/newiris.jpg", description: "A chic display design that offers a sophisticated look for showcasing chocolate.", route: "/iris" },
  { name: "Vista", category: "Display", image: "images/vista2.jpg", description: "Elegant design to display chocolate in an accessible and visually appealing way.", route: "/vista" },
  { name: "Kubo", category: "Display", image: "images/newkubo.jpg", description: "A contemporary design, ideal for small to medium-sized chocolate displays.", route: "/kubo" },
  { name: "E-Line", category: "Display", image: "images/neweline.jpg", description: "Minimalistic and space-efficient design, great for showcasing chocolate products in retail environments.", route: "/e-line" },
  { name: "Daisy", category: "Display", image: "images/newdaisy.jpg", description: "A stylish design that elevates the presentation of your chocolate offerings.", route: "/daisy-lower" },
  { name: "Passion Lux", category: "Display", image: "images/passionlux.jpg", description: "A luxurious display model designed to showcase premium chocolates.", route: "/passionlux" },
];



const icons = [
  { name: "Box", icon: <FaBox /> },
  { name: "Cube", icon: <FaCube /> },
  { name: "Shopping Bag", icon: <FaShoppingBag /> },
];

function ChocolateDisplay() {
  const [currentPage, setCurrentPage] = useState(1);
  const modelsPerPage = 6;
  const navigate = useNavigate();

  // Get the current models for the current page
  const indexOfLastModel = currentPage * modelsPerPage;
  const indexOfFirstModel = indexOfLastModel - modelsPerPage;
  const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

  // Handle page change
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const totalPages = Math.ceil(models.length / modelsPerPage);

  return (
    <div className="w-full font-thin">
      {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/choclateland2.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
       
      </section>

      {/* Models Display */}
      <section className="px-6 py-12 md:px-32">
        <section className="px-6 md:px-32">
        <div className="flex flex-col items-center justify-center text-black p-6">
          <h1 className="text-3xl mb-4 md:text-4xl text-center">Chocolate</h1>
          <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
          We highlight the best Chocolates: bonbons, truffles, pralines, in specialist counters and granting the best visibility!
          </p>
        </div>

        <div className="flex justify-center">
          <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
          <button className="block py-1 pl-4 hover:underline uppercase mt-6">Chocolate</button>
        </div>
      </section>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {currentModels.map((model, index) => (
            <div key={index} onClick={() => navigate(model.route)} className="text-center cursor-pointer">
              <div
                className="relative w-full h-80 mb-4"
                style={{
                  backgroundImage: `url(${model.image})`,
                  backgroundSize: "contain", // Ensures no cuts, full image shown
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  height: "300px",
                }}
              ></div>
              <h3 className="text-3xl uppercase font-thin mb-2">{model.name}</h3>
              {/* <p className="text-xl opacity-80 ">{model.category}</p> */}
              <p className="text-xl text-gray-500 max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

              {/* Small icons under each model */}
              <div className="flex justify-center gap-4">
                {icons.map((icon, index) => (
                  <div key={index} className="text-2xl">
                    {icon.icon}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-10">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-800 text-white rounded-l"
          >
            Previous
          </button>
          <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-800 text-white rounded-r"
          >
            Next
          </button>
        </div>
      </section>
    </div>
  );
}
export default ChocolateDisplay;


// import React, { useState } from "react";
// import { FaBox, FaCube, FaShoppingBag } from "react-icons/fa";

// const models = [
//   { name: "Minimal", category: "Display", image: "images/minimal.jpg", description: "A sleek and modern display model, perfect for premium chocolate brands." },
//   { name: "Iris", category: "Display", image: "images/iris.jpg", description: "A chic display design that offers a sophisticated look for showcasing chocolate." },
//   { name: "Vista", category: "Display", image: "images/vista.jpg", description: "Elegant design to display chocolate in an accessible and visually appealing way." },
//   { name: "Kubo", category: "Display", image: "images/kubo.jpg", description: "A contemporary design, ideal for small to medium-sized chocolate displays." },
//   { name: "E-Line", category: "Display", image: "images/eline.jpg", description: "Minimalistic and space-efficient design, great for showcasing chocolate products in retail environments." },
//   { name: "Daisy", category: "Display", image: "images/daisy.png", description: "A stylish design that elevates the presentation of your chocolate offerings." },
//   { name: "Passion Lux", category: "Display", image: "images/passionlux.jpg", description: "A luxurious display model designed to showcase premium chocolates." },
// ];

// const icons = [
//   { name: "Box", icon: <FaBox /> },
//   { name: "Cube", icon: <FaCube /> },
//   { name: "Shopping Bag", icon: <FaShoppingBag /> },
// ];

// function ChocolateDisplay() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const modelsPerPage = 6;

//   // Get the current models for the current page
//   const indexOfLastModel = currentPage * modelsPerPage;
//   const indexOfFirstModel = indexOfLastModel - modelsPerPage;
//   const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

//   // Handle page change
//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

//   // Calculate total pages
//   const totalPages = Math.ceil(models.length / modelsPerPage);

//   return (
//     <div className="w-full">
//       {/* Hero Section */}
//       <section
//         className="relative text-center w-full h-screen"
//         style={{
//           backgroundImage: "url('images/choclateland2.jpg')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
//           <h1 className="text-4xl font-bold mb-4 md:text-8xl">Chocolate Display Models</h1>
//           <p className="text-lg max-w-2xl md:text-3xl">
//             Discover the best display models for showcasing your premium chocolates.
//           </p>
//         </div>
//       </section>

//       {/* Models Display */}
//       <section className="px-6 py-12 md:px-32">
//         <h2 className="text-4xl md:text-7xl font-bold text-center mb-10">Our Chocolate Display Models</h2>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
//           {currentModels.map((model, index) => (
//             <div key={index} className="text-center">
//               <div
//                 className="relative w-full h-80 mb-4"
//                 style={{
//                   backgroundImage: `url(${model.image})`,
//                   backgroundSize: "contain", // Ensures no cuts, full image shown
//                   backgroundPosition: "center",
//                   backgroundRepeat: "no-repeat",
//                   height: "300px",
//                 }}
//               ></div>
//               <h3 className="text-2xl font-semibold mb-2">{model.name}</h3>
//               <p className="text-sm opacity-80 ">{model.category}</p>
//               <p className="text-sm max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

//               {/* Small icons under each model */}
//               <div className="flex justify-center gap-4">
//                 {icons.map((icon, index) => (
//                   <div key={index} className="text-2xl">
//                     {icon.icon}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Pagination */}
//         <div className="flex justify-center mt-10">
//           <button
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//             className="px-4 py-2 bg-gray-800 text-white rounded-l"
//           >
//             Previous
//           </button>
//           <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
//           <button
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 bg-gray-800 text-white rounded-r"
//           >
//             Next
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default ChocolateDisplay;

